import { PasErrorCode } from './pas-error-code.model';

export class PasSecurityDetailsPartialError {
	constructor(public readonly errorCodes: Map<string, PasErrorCode>, public readonly errorPortfolios: PasErrorPortfolioDetails[], public readonly isPartialError?: boolean) { }
}

export interface PasErrorPortfolioDetails {
	id: string;
	description: string;
}
